import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAutoFlash: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"auto-flash"} maskId="square-filled-radius-0-stroke-1-IconAutoFlash"><path d="M14.0014 0.212402L2.51953 16H10.0014V23.7876L21.4833 7.99999H14.0014V0.212402Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M23.1016 23L21.4216 14L20.7454 13.9678L15.1016 23H16.3016L17.3483 21.2857H21.7634L22.0816 23H23.1016ZM21.5768 20.2856H17.9742L20.7454 15.8517L21.5768 20.2856Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAutoFlash;
